import React from "react";
import { Box, Button, Typography, Grid2, TextField, Radio, Select, MenuItem,FormControl,InputLabel } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import SignUpBg from "../../../Assets/Images/Signup_web.png";
import StepperCard from ".././StepperCard";
import { CustomStepConnector, StepIcon, useSteps  } from ".././StepperComponents"; // Import steps
import { useSelector, useDispatch } from 'react-redux';
import { checkAndNavigate, setActiveStep, setChequeUploadStatus, setChequeUploadStatusFromRelogin } from "../../../Redux/usersSlice";
import icon from "../../../Assets/Images/icon.svg"
import BankStyles from "./Bank.module.css"
import { useState,useEffect } from "react";
import success from "../../../Assets/Images/bvsuccess.svg"
import { FileUploader } from "react-drag-drop-files";
import lock from "../../../Assets/Images/lock.svg"
import navLogo from "../../../Assets/Images/logo.svg";
import banKicon from "../../../Assets/Images/bankk.svg"
import upiIcon from "../../../Assets/Images/upi.svg"
import { verifyBank, ocrCheck, setTraditionalToDetails, setDetailsToTraditional, setOkToTraditional, setSuccess, confirmBank, chequeUpload, setChequeUpload, setBankDetailsToNull, setChequeToTraditional, setBankServerError, setOkToDetails, setIsVerified } from "../../../Redux/usersSlice";
import * as pdfjsLib from "pdfjs-dist";
import { useMediaQuery } from "@mui/system";
import collab from '../../../Assets/Images/collab1.svg';
pdfjsLib.GlobalWorkerOptions.workerSrc =
    "https://unpkg.com/pdfjs-dist@2.10.377/build/pdf.worker.min.js";




export default function LinkBankAccount() {
  const steps = useSteps();
  const navigate = useNavigate();
  const location = useLocation();

  const dispatch = useDispatch();

  const { activeStep, loading, userData, error, traditionalBank, bankDetailsPage, bankSuccess, chequeStatus, bankDetails, bankData, bankServerError, chequeuploded, chequeuplodedFromRelogin,source } = useSelector(state => state.user);

  console.log("LOader",loading)

    // const theme = useTheme();
    const isMobile = useMediaQuery('(max-width:1000px)');

  const backendResponse = userData.steps
  const email = userData?.email.toLowerCase();
  const mobile = userData?.mobile;

  const [accNo, setAccNo] = useState(null);






  console.log("accno", accNo)

  const [ifsc, setIfsc] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [confirmAccountNumber, setConfirmAccountNumber] = useState("");
  const [upiId, setUpiId] = useState("");
  const [oneRupee, serOneRupee] = useState("")
  const [chequeData, setChequeData] = useState(null)
  const [chequeError, setChequeError] = useState("")
  const [fileName, setFileName] = useState("");
  const [enable, setEnable] = useState(false)
  const [filetype,setFiletype]=useState("")
  const [uploadData,setUpload]=useState("")
  const [isAccountNumberFocused, setIsAccountNumberFocused] = useState(false);
 const [chequeFileUploader, setChequeFileUploader] = React.useState(true)



  const [accountType, setAccountType] = useState("")
  const [submitAttempted, setSubmitAttempted] = useState(false);


  const [selectedOption, setSelectedOption] = React.useState("manual");

  const [errors, setErrors] = useState({
    ifsc: "",
    accountNumber: "",
    confirmAccountNumber: "",
    accountType: "",
    upiId: ""
  });
  const [serverError, setServerError] = useState("");
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "kyc_step_viewed",
      step_name: "bank_page_viewed",
      page_path: window.location.pathname
    });
  }, [])

  React.useEffect(() => {
    if (bankData?.verification_type === "Manual"){
      dispatch(setChequeUploadStatusFromRelogin(true))
    }
  }, []);
  
  React.useEffect(() => {
    const processOcr = async () => {
      if (fileName && chequeData && filetype) {
        console.log("Processing OCR");
        await handleChequeOcr();
      }
    };

    if (fileName && chequeData && filetype) {
      processOcr();
    }
  }, [fileName, chequeData, filetype]);

  React.useEffect(() => {

    if(bankData){
      if (bankData?.account_name !== null ) {
        console.log("hellloooo");
        if(bankSuccess !== true){
          if(bankData.is_verified == 1){
            dispatch(setIsVerified())
          }
          dispatch(setTraditionalToDetails(bankData))
        }
        let lastFourDigits = bankData.account_number.slice(-4);
        setAccNo(lastFourDigits);
      }
    }
      else if (bankDetails) {
        // dispatch(setTraditionalToDetails(bankDetails))
        let lastFourDigits = bankDetails.account_number.slice(-4);
        setAccNo(lastFourDigits);
      }
  }, [bankData, bankDetails]);

  const handleChequeOcr = async () => {
    console.log("Payload:", chequeData, email, mobile, filetype);
     setChequeFileUploader(false)
    try {
      const response = await dispatch(
        ocrCheck({
          mobile,
          email,
          filetype,
          base64: chequeData,
          type: "cheque"
        })
      ).unwrap();


      console.log("Response:", response.data);

      if (response.data.response.success) {
        console.log("inside cheque ocr success")
        setEnable(true);
        setChequeData("");
        setFiletype("");
        handleChequeUpload(chequeData)
        setChequeFileUploader(true)
        dispatch(setChequeUploadStatus(true))
        dispatch(setChequeUploadStatusFromRelogin(true))
        // setUpload(chequeData)
      } else {
        setFileName("");
        setFiletype("");
        setChequeData("");
        setEnable(false);
        setChequeFileUploader(true)
        setChequeError(response.data.response.message);
      }
    } catch (error) {
      console.error("Bank verification failed:", error);
      const errMessage = error?.data?.data?.message
      setChequeError(errMessage || "Cheque Verification Failed")
    }
  };

  const handlePicFile = async (file) => {
    if (!file) {
      console.error("No file selected.");
      setEnable(false);
      return;
    }

    const validImageTypes = ["image/jpeg", "image/png", "image/jpg"];
    if (!validImageTypes.includes(file.type)) {
      setChequeError("Invalid file type. Please upload an image (JPEG, PNG, JPG).");
      setFileName("");
      setEnable(false);
      return;
    }

    const maxSize = 5 * 1024 * 1024; // 5 MB
    if (file.size > maxSize) {
      setChequeError("File size exceeds the 5MB limit.");
      setFileName("");
      setEnable(false);
      return;
    }

    const fileType = file.type.split("/")[1] === "jpeg" ? "jpg" : file.type.split("/")[1];
    setFiletype(fileType); // Set filetype here
    setFileName(file.name); // Set fileName here

    try {
      const fileReader = new FileReader();
      fileReader.onload = () => {
        const base64Image = fileReader.result.split(",")[1];
        const data = `data:image/${fileType};base64,${base64Image}`;
        setChequeData(data); // Set chequeData here
        setChequeError("");
        setEnable(false); // Disable further interactions until OCR completes
      };

      fileReader.readAsDataURL(file); // Start Base64 encoding
    } catch (error) {
      console.error("Error reading file:", error);
    }
  };

  
 
  

  const validateField = (field, value, isSubmission = false) => {
    let isValid = true;
    let errorMessage = "";

    switch (field) {
      case "ifsc":
        if (value.trim() === "") {
          errorMessage = "IFSC is required.";
          isValid = false;
        } else if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(value)) {
          errorMessage = "Invalid IFSC code format.";
          isValid = false;
        }
        break;

      case "accountNumber":
        if (value.trim() === "") {
          errorMessage = "Bank account number is required.";
          isValid = false;
        } else if (!/^\d{9,18}$/.test(value)) {
          errorMessage = "Account number must be 9 to 18 digits.";
          isValid = false;
        }
        break;

      case "confirmAccountNumber":
        if (isSubmission || (accountNumber && value)) {
          if (value.trim() === "") {
            errorMessage = "Confirm account number is required.";
            isValid = false;
          } else if (value !== accountNumber) {
            errorMessage = "Account numbers do not match.";
            isValid = false;
          }
        }
        break;

      case "accountType":
        if (!value || value.trim() === "") {
          errorMessage = "Account type is required.";
          isValid = false;
        }
        break;

      case "upiId":
        if (value.trim() !== "") {
          const upiRegex = /^[a-zA-Z0-9.\-_]{2,256}@[a-zA-Z]{2,64}$/;
          if (!upiRegex.test(value)) {
            errorMessage = "Invalid UPI ID format.";
            isValid = false;
          }
        }
        break;

      default:
        break;
    }


    if (isSubmission || (errors[field] && isValid) || (!isValid && value.trim() !== "")) {
      setErrors((prev) => ({ ...prev, [field]: errorMessage }));
    }

    return isValid;
  };

  const handleInputChange = (field, value) => {

    switch (field) {
      case "ifsc":
        setIfsc(value.toUpperCase());
        validateField(field, value);
        break;
      case "accountNumber":
        setAccountNumber(value);
        validateField(field, value);
        if (confirmAccountNumber) {
          validateField("confirmAccountNumber", confirmAccountNumber);
        }
        break;
      case "confirmAccountNumber":
        setConfirmAccountNumber(value);

        if (accountNumber) {
          validateField(field, value);
        }
        break;
      case "accountType":
        setAccountType(value);
        validateField(field, value);
        break;
      case "upiId":
        setUpiId(value);
        break;
      default:
        break;
    }

    if (errors[field]) {
      const isValid = validateField(field, value);
      if (isValid) {
        setErrors(prev => ({ ...prev, [field]: "" }));
      }
    }
  };





  const handleContinue = async (e) => {
    e.preventDefault();
    setSubmitAttempted(true);
    setServerError("")

    const fieldsToValidate = [
      { field: "accountType", value: accountType },
      { field: "ifsc", value: ifsc },
      { field: "accountNumber", value: accountNumber },
      { field: "confirmAccountNumber", value: confirmAccountNumber },
      { field: "upiId", value: upiId },

    ];

    let isFormValid = true;

    for (const { field, value } of fieldsToValidate) {
      if (!validateField(field, value, true)) {
        isFormValid = false;
        const invalidField = document.querySelector(`[name="${field}"]`);
        if (invalidField) {
          invalidField.focus();
          invalidField.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        break;
      }
    }

    if (!isFormValid) return;


    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "kyc_step_viewed",
      step_name: "bank_traditional",
      page_path: window.location.pathname
    });
    try {
      const response = await dispatch(verifyBank({
        mobile,
        email,
        ifsc,
        accountNumber,
        accountType,
        upiId
      })).unwrap();

      console.log("response", response.data)
      let code = response.data.data.code
      let status = response.data.status
      let data = response.data.data
      data.account_type = accountType
      data.ifsc_code = ifsc
      data.upi_id = upiId
      data.account_number = accountNumber

      if (status == 200) {
        if (code === 1) {
          console.log("dddaattaaa", data)
          
          dispatch(setTraditionalToDetails(data))
          setSubmitAttempted(false);
          setIfsc("");
          setAccountNumber("");
          setConfirmAccountNumber("");
          setAccountType("");
          setErrors({
            ifsc: "",
            accountNumber: "",
            confirmAccountNumber: "",
            accountType: "",
          })
          dispatch(setChequeUploadStatus(false))
          dispatch(setChequeUploadStatusFromRelogin(false))
        } else if (code === 5 || code === 8) {
          setSubmitAttempted(false);
          dispatch(setChequeUpload())
          dispatch(setBankServerError(response.data.data.message))
        } else {
          setErrors({
            ifsc: "",
            accountNumber: "",
            confirmAccountNumber: "",
            accountType: "",
            upiId: ""
          })
          setSubmitAttempted(false);
          setServerError(response.data.data.message)
        }
      }

    } catch (error) {
      setSubmitAttempted(false);
      setServerError("Bank verification failed. please try again.")
      console.error('Bank verification failed:', error);
    }
  };



  

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };


  const handleBack = () => {
    dispatch(setDetailsToTraditional())
  }

  const handleDetailsContinue = async (e) => {
    try {
      const response = await dispatch(confirmBank({
        mobile,
        email,
      })).unwrap();

      console.log("response", response.data)
      if (response.data.status === 200) {
        // dispatch(setSuccess())
        dispatch(setIsVerified())
        handleBankOk()
      }
    } catch (error) {
      console.error('Bank verification failed:', error);
    }
  }


  const handleChequeUpload = async (chequeData) => {
    // e.preventDefault()
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "kyc_step_viewed",
      step_name: "bank_cheque",
      page_path: window.location.pathname
    });
    try {
      const response = await dispatch(chequeUpload({
        mobile,
        email,
        uploadData: chequeData
      })).unwrap();

      console.log("response", response.data.data.success)
      if (response.data.data.success === true) {
        // dispatch(setSuccess())
        dispatch(setBankDetailsToNull())
        handleDetailsContinue()
      }else{
        setChequeError(response.data.data.message)
      }
    } catch (error) {
      console.error('Error uploading cheque:', error);
    }
  }



  const handleChequeBack = () => {
    dispatch(setChequeToTraditional())
  }


  const handleBankOk = async () => {
    if(bankDetails){
      dispatch(setOkToDetails())
    }else{
      dispatch(setOkToTraditional())
    }
    const { payload } = await dispatch(checkAndNavigate());

    console.log(payload.allComplete)

    if (payload.allComplete) {
      // All required steps completed - go to products
      console.log("Navigating to dis page...")
      navigate("/dis");
    }else{

       // First check if there are incomplete steps forward (normal flow)
       let nextIncompleteStep = null;
           
       // Check forward steps first
       for (let i = activeStep + 1; i < steps.length; i++) {
         const step = steps[i];
         const isComplete = step.substeps
           ? step.substeps.every(sub => userData.steps[sub.name]?.status)
           : userData.steps[step.name]?.status;
         console.log("Forward steps completed --->", isComplete)
   
         if (!isComplete) {
           nextIncompleteStep = step;
           console.log("Forward steps Incomplete navigating to", JSON.stringify(step))
           break;
         }
       }
   
       // If no incomplete steps forward, check all steps
       if (!nextIncompleteStep) {
         console.log("No incomplete steps forward checking any in backward steps")
         for (let i = 0; i < steps.length; i++) {
           const step = steps[i];
           const isComplete = step.substeps
             ? step.substeps.every(sub => userData.steps[sub.name]?.status)
             : userData.steps[step.name]?.status;
   
           if (!isComplete) {
             nextIncompleteStep = step;
             console.log("Backward steps Incomplete navigating to", JSON.stringify(step))
             break;
           }
         }
       }
   
       const stepIndex = steps.findIndex(s => s.path === nextIncompleteStep.path);
       console.log("Navigating to the specific step according to the condition", stepIndex)
       if (stepIndex !== -1) {
         dispatch(setActiveStep(stepIndex));
         navigate(nextIncompleteStep.path);
       }

    }

  }

  const isFormValid =
    ifsc.length === 11 &&
    accountNumber.length > 0 &&
    confirmAccountNumber === accountNumber &&
    accountType.length > 0



  // Sync step with URL path
  React.useEffect(() => {
    const currentStep = steps.findIndex(
      (step) => step.path === location.pathname
    );
    if (currentStep !== -1) dispatch(setActiveStep(currentStep));
  }, [location.pathname, setActiveStep]);

  const handleNext = () => {
    if (activeStep < steps.length - 1) {
      const nextStep = activeStep + 1;
      dispatch(setActiveStep(activeStep + 1));
      navigate(steps[nextStep].path);
    }
  };

  const handleSkip = () => {
    if (activeStep < steps.length - 1) {
      const nextStep = activeStep + 1;
      dispatch(setActiveStep(activeStep + 1));
      navigate(steps[nextStep].path);
    }
  };

  const handleStepNavigate = (path) => {
    const stepIndex = steps.findIndex((step) => step.path === path);
    if (stepIndex !== -1) {
      dispatch(setActiveStep(stepIndex));
      navigate(path);
    }
  };


  const handleSkipBV=()=>{

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "kyc_step_viewed",
      step_name: "bank_skipped",
      page_path: window.location.pathname
    });
     // First check if there are incomplete steps forward (normal flow)
               let nextIncompleteStep = null;
                   
               // Check forward steps first
               for (let i = activeStep + 1; i < steps.length; i++) {
                 const step = steps[i];
                 const isComplete = step.substeps
                   ? step.substeps.every(sub => userData.steps[sub.name]?.status)
                   : userData.steps[step.name]?.status;
                 console.log("Forward steps completed --->", isComplete)
           
                 if (!isComplete) {
                   nextIncompleteStep = step;
                   console.log("Forward steps Incomplete navigating to", JSON.stringify(step))
                   break;
                 }
               }
           
               // If no incomplete steps forward, check all steps
               if (!nextIncompleteStep) {
                 console.log("No incomplete steps forward checking any in backward steps")
                 for (let i = 0; i < steps.length; i++) {
                   const step = steps[i];
                   const isComplete = step.substeps
                     ? step.substeps.every(sub => userData.steps[sub.name]?.status)
                     : userData.steps[step.name]?.status;
           
                   if (!isComplete) {
                     nextIncompleteStep = step;
                     console.log("Backward steps Incomplete navigating to", JSON.stringify(step))
                     break;
                   }
                 }
               }
           
               const stepIndex = steps.findIndex(s => s.path === nextIncompleteStep.path);
               console.log("Navigating to the specific step according to the condition", stepIndex)
               if (stepIndex !== -1) {
                 dispatch(setActiveStep(stepIndex));
                 if(stepIndex === activeStep){
                      window.alert("You’ve reached the last step of onboarding, and it must be completed to continue ...!")
                 }else{
                 navigate(nextIncompleteStep.path);
                 }
               }
  }




  return (
    <main>
    <Box sx={{
      display: "flex",
      flexDirection:isMobile ? "column" : "row",
      minHeight: "100vh !important",
      backgroundImage: `url(${SignUpBg})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
    }}>

      <Typography
        sx={{
          textAlign: "center",
          fontSize: "16px",
          fontFamily: "Inter400",
          display: {
            xs: "block", // shown on small screens
          },
          mt: "5px",
          "@media (min-width:1000px)": {
            display: "none"
          }
        }}
      >
        {`You are on step ${activeStep + 1} out of 8`}
      </Typography>



      <StepperCard
        activeStep={activeStep}
        handleStepNavigate={handleStepNavigate}
        backendResponse={backendResponse}
        CustomStepConnector={CustomStepConnector}
        StepIcon={StepIcon}
        steps={steps}
      />

        {/* Your content area */}
      <Box className={BankStyles.content_wrapper}>
        <img src={source == "cosmos" ? collab : navLogo} alt="Logo" className={source == "cosmos" ? BankStyles.twologo :
          BankStyles.nav_logo} />
        {
          source == "cosmos" &&
          <Typography className={BankStyles.txt1}>
            Together with Tradeboss, CFG India simplifies Investing in Listed/ Unlisted securities.
          </Typography>
        }

        <Typography className={BankStyles.heading}>
          Link bank account
        </Typography>
        {(chequeuploded || chequeuplodedFromRelogin)&& (
          <Box
            sx={{
              m: 2,
              p: { xs: 1.5, sm: 2 }, // smaller padding on mobile
              borderRadius: "10px",
              backgroundColor: "#E6F4EA",
              border: "1px solid #4CAF50",
              display: "flex",
              alignItems: "flex-start",
              gap: 1,
              flexWrap: "wrap", // ensures wrapping on small screens
            }}
          >
            <Typography
              variant="body2" // smaller font than body1
              sx={{
                color: "#2E7D32",
                fontWeight: 500,
                fontSize: { xs: "0.8rem", sm: "0.9rem" }, // responsive font
                lineHeight: 1.4,
              }}
            >
              Your cancelled cheque has been uploaded successfully. <br />
              We will verify the details and update your bank account during KYC verification.
            </Typography>
          </Box>

        )}
        <Typography className={BankStyles.sub_title}>
          Bank account in your name from which you will transact funds for
          trading.
        </Typography>


        {
          traditionalBank &&
          <>
            {/* <Grid2 className={BankStyles.options_container}>



                <Grid2
                  item
                  xs={6}
                  className={`${BankStyles.option} ${selectedOption === "manual" ? BankStyles.selected : ""
                    }`}
                >
                  <Grid2 className={BankStyles.img_card1}>
              
                    <img src={banKicon} alt="bankLogo"  />
                  </Grid2>

                  <Typography className={BankStyles.option_text}>
                    Add Bank Details Manually
                  </Typography>

                  <Radio
                    checked={selectedOption === "manual"}
                    onChange={handleOptionChange}
                    value="manual"
                    name="bank-options"
                    className={`${BankStyles.radio} ${selectedOption === "manual" ? BankStyles.radioSelected : ""
                      }`}
                  />
                </Grid2>

                <Grid2
                  item
                  xs={6}
                  className={`${BankStyles.option} ${selectedOption === "upi" ? BankStyles.selected : ""
                    }`}
                >
                  <Grid2 className={BankStyles.img_card1}>
                 
                    <img src={upiIcon} alt="upiLogo"  />
                    
                  </Grid2>

                  <Typography className={BankStyles.option_text}>
                    Verify with UPI
                  </Typography>

                  <Radio
                    checked={selectedOption === "upi"}
                    onChange={handleOptionChange}
                    value="upi"
                    name="bank-options"
                    className={`${BankStyles.radio} ${selectedOption === "upi" ? BankStyles.radioSelected : ""
                      }`}
                  />
                </Grid2>

              </Grid2> */}




            <Grid2 sx={{ display: "flex", flexDirection: "column", marginTop: "20px !important" }}>



              <FormControl className={`${BankStyles.formControl}`}>
                <InputLabel
                  id="nominee-relation-label"
                  className={`${BankStyles.label}`}
                  shrink={false}
                  sx={{
                    position: "absolute",
                    top: "35%",
                    left: "55px",
                    transform: "translateY(-50%)",
                    fontSize: "14px !important",
                    fontFamily: "Inter400 !important",
                    color: "#767676 !important",
                    pointerEvents: "none",
                    transition: "all 0.2s ease",
                    display: accountType ? "none" : "block",
                    "@media (max-width: 1250px)": { left: "34px" },
                    "@media (max-width: 1150px)": { left: "15px" },
                    "@media (max-width: 1080px)": { left: "5px" },
                    "@media (max-width: 1000px)": { left: "20px" },
                    "@media (max-width: 769px)": { left: "0px" },
                    "@media (max-width: 680px)": { left: "-5px" },
                    "@media (max-width: 600px)": { top:"26%" },
                  }}
                >
                  Account Type
                </InputLabel>
                {/* <Select
                  labelId="nominee-relation-label"
                  value={accountType}
                  onChange={(e) => handleInputChange("accountType", e.target.value)}
                  displayEmpty
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        width: "150px",
                        height: "85px",
                        fontFamily: "Inter400",

                      },
                    },
                  }}
                  sx={{
                    width: "100%",
                    height: "42px",
                    border: errors.accountType ? "1px solid #EC0707" : "1px solid #D9D9D9",
                    borderRadius: "39px",
                    background: "#ffffff",
                    display: "flex",
                    alignItems: "center",
                    padding: "20px 0",
                    fontFamily: "Inter400",
                    fontSize: "18px",
                    textAlign: "center",


                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },


                    "&.Mui-focused": {
                      border: errors.accountType ? "1px solid #EC0707" : "1px solid #D9D9D9",
                    },
                    "&:hover": {
                      border: errors.accountType ? "1px solid #EC0707" : "1px solid #D9D9D9",
                    },


                    "& .MuiSelect-icon": {
                      color: "#000000",
                    },


                    "&.Mui-focused.Mui-expanded": {
                      border: errors.accountType ? "1px solid #EC0707" : "1px solid #D9D9D9",
                    },
                  }}
                >
                  <MenuItem className={BankStyles.item} value="Savings">
                    Savings
                  </MenuItem>
                  <MenuItem className={BankStyles.item} value="Current">
                    Current
                  </MenuItem>
                </Select> */}

                <Select
                  labelId="nominee-relation-label"
                  value={accountType}
                  onChange={(e) => handleInputChange("accountType", e.target.value)}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        width: "150px",
                        maxHeight: "180px",
                        fontFamily: "Inter400",
                        borderRadius: "12px",
                        boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                      },
                    },
                  }}
                  sx={{
                    width: "100%",
                    height: "42px",
                    border: errors.accountType ? "1px solid #EC0707" : "1px solid #D9D9D9",
                    borderRadius: "39px",
                    background: "#ffffff",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    fontFamily: "Inter400",
                    fontSize: "18px",
                    padding: "0 14px",
                    "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                    "&:hover .MuiOutlinedInput-notchedOutline": { border: "none" },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "none" },
                    "&.Mui-focused": {
                      border: errors.accountType ? "1px solid #EC0707" : "1px solid #D9D9D9",
                    },
                    "&:hover": {
                      border: errors.accountType ? "1px solid #EC0707" : "1px solid #D9D9D9",
                    },
                    "& .MuiSelect-icon": {
                      color: "#000000",
                      right: "12px",
                    },
                    "@media (max-width:600px)": {
                      height: "36px",
                      fontSize: "14px",
                      padding: "0 10px",
                    },
                  }}
                >
                  <MenuItem value="Savings">Savings</MenuItem>
                  <MenuItem value="Current">Current</MenuItem>
                </Select>
              </FormControl>





              {submitAttempted && errors.accountType && (
                <span style={{
                  color: "#EC0707",
                  fontSize: "12px",
                  marginTop: "4px",
                  fontFamily: "Inter400",
                  textAlign: "center",
                }}>
                  {errors.accountType}
                </span>
              )}


              <TextField
                variant="outlined"
                placeholder="Link using IFSC"
                value={ifsc}
                onChange={(e) => {
                  const value = e.target.value.toUpperCase().trim(); // Convert to uppercase for IFSC
                  if (/^[A-Z0-9]*$/.test(value) && value.length <= 11) {
                    handleInputChange("ifsc", value); // Allow only valid characters
                  }
                }}

                autoComplete="off"
                inputProps={{
                  autoComplete: "new-password",
                }}
                sx={{
                  marginTop: "16px",
                  backgroundColor: "white",
                  borderRadius: "39px",

                  "& input": {
                    display: "flex",
                    alignItems: "center",
                    padding: "8px 12px",
                    textAlign: "center !important",
                    fontFamily: "Inter400 !important",
                    fontSize: "18px !important",
                    lineHeight: "29px !important",

                    "&::placeholder": {
                      padding: "11px 12px",
                      fontSize: "14px !important", // Adjust placeholder font size
                      lineHeight: "100%",
                      fontFamily: "Inter400 !important",
                      color: "#767676",
                      opacity: 1, // Required for Firefox
                    },
                    "@media (max-width: 1250px)": {
                      "&::placeholder": {
                        fontSize: "14px !important", // Adjust placeholder font size for smaller screens
                      },

                    },
                    "@media (max-width: 680px)": {
                      "&::placeholder": {
                        fontSize: "14px !important", // Adjust placeholder font size for smaller screens
                      }
                    },
                  },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderRadius: "39px",
                      height: "46px !important",
                      width: "383px !important",
                      borderColor: submitAttempted && errors.ifsc ? "#EC0707" : "#D9D9D9", // Ensure border color is constant
                      "@media (max-width: 1250px)": {
                        width: "333px !important",
                      },
                      "@media (max-width: 1150px)": {
                        width: "303px !important",
                      },
                      "@media (max-width: 1080px)": {
                        width: "273px !important",
                      },
                      "@media (max-width: 1000px)": {
                        width: "303px !important",
                      },
                      "@media (max-width: 769px)": {
                        width: "273px !important",
                      },
                      "@media (max-width: 680px)": {
                        width: "271px !important",
                      }
                    },
                    "&:hover fieldset": {
                      borderColor: submitAttempted && errors.ifsc ? "#EC0707" : "#D9D9D9", // Keep border color consistent on hover
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: submitAttempted && errors.ifsc ? "#EC0707" : "#D9D9D9", // Ensure no border color change on focus
                      borderWidth: "1px", // Optional: Maintain consistent border width
                    },
                  },
                  "& .MuiFormHelperText-root": {
                    marginTop: "5px !important",
                    fontFamily: "Inter400 !important",
                    fontSize: "12px !important",
                    color: "#FF0000 !important", // Example error color
                  },
                  width: "399px",
                  height: "42px !important",
                  "@media (max-width: 1250px)": {
                    width: "350px !important",
                  },
                  "@media (max-width: 1150px)": {
                    width: "320px !important",
                  },
                  "@media (max-width: 1080px)": {
                    width: "290px !important",
                  },
                  "@media (max-width: 1000px)": {
                    width: "320px !important",
                  },
                  "@media (max-width: 769px)": {
                    width: "290px !important",
                  },
                  "@media (max-width: 680px)": {
                    width: "288px !important",
                  }
                }}
              />

              {submitAttempted && errors.ifsc && (
                <span style={{
                  color: "#EC0707",
                  fontSize: "12px",
                  marginTop: "5px",
                  fontFamily: "Inter400",
                  textAlign: "center",
                }}>
                  {errors.ifsc}
                </span>
              )}

             
              <TextField
                variant="outlined"
                placeholder="Bank account number"
                type={isAccountNumberFocused ? "text" : "password"} // Toggle between text and password type
                value={isAccountNumberFocused ? accountNumber : accountNumber} // Show actual value in both cases
                // onChange={(e) => {
                //   const newChar = e.nativeEvent.data;
                //   if (newChar && /^\d$/.test(newChar)) {
                //     const newValue = accountNumber + newChar;
                //     if (newValue.length <= 18) {
                //       handleInputChange("accountNumber", newValue);
                //     }
                //   } else if (e.target.value.length < accountNumber.length) {
                //     handleInputChange("accountNumber", accountNumber.slice(0, -1));
                //   }
                // }}

                onChange={(e) => {
                  const inputValue = e.target.value;
                  const numbersOnly = inputValue.replace(/\D/g, "").trim(); // remove non-numeric chars
                  if (numbersOnly.length <= 18) {
                    handleInputChange("accountNumber", numbersOnly);
                  }
                }}
                onFocus={() => setIsAccountNumberFocused(true)}
                onBlur={() => setIsAccountNumberFocused(false)}
                onPaste={(e) => {
                  e.preventDefault();
                  const pastedData = e.clipboardData.getData('text/plain');
                  const numbersOnly = pastedData.replace(/\D/g, '').trim();
                  if (numbersOnly.length > 0) {
                    const newValue = accountNumber + numbersOnly;
                    handleInputChange("accountNumber", newValue.slice(0, 18));
                  }
                }}
                inputProps={{
                  autoComplete: "off",
                  inputMode: "numeric",
                  name: "hidden-bank-account",
                  id: "hidden-bank-account-" + Math.random().toString(36).substring(2)
                }}
                sx={{
                  backgroundColor: "white",
                  borderRadius: "39px",
                  marginTop: "16px",
                  "& input": {
                    display: "flex",
                    alignItems: "center",
                    padding: "8px 12px",
                    textAlign: "center !important",
                    fontFamily: "Inter400 !important",
                    fontSize: "18px !important",
                    lineHeight: "29px !important",
                    "&::placeholder": {
                      padding: "11px 12px",
                      fontSize: "14px !important",
                      fontFamily: "Inter400 !important",
                      color: "#767676",
                      opacity: 1, // Required for Firefox
                    },
                    "@media (max-width: 1250px)": {
                      "&::placeholder": {
                        fontSize: "14px !important",
                      },
                    },
                    "@media (max-width: 680px)": {
                      "&::placeholder": {
                        fontSize: "14px !important",
                      }
                    },
                  },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderRadius: "39px",
                      height: "46px !important",
                      width: "383px !important",
                      borderColor: submitAttempted && errors.accountNumber ? "#EC0707" : "#D9D9D9",
                      "@media (max-width: 1250px)": {
                        width: "333px !important",
                      },
                      "@media (max-width: 1150px)": {
                        width: "303px !important",
                      },
                      "@media (max-width: 1080px)": {
                        width: "273px !important",
                      },
                      "@media (max-width: 1000px)": {
                        width: "303px !important",
                      },
                      "@media (max-width: 769px)": {
                        width: "273px !important",
                      },
                      "@media (max-width: 680px)": {
                        width: "271px !important",
                      }
                    },
                    "&:hover fieldset": {
                      borderColor: submitAttempted && errors.accountNumber ? "#EC0707" : "#D9D9D9",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: submitAttempted && errors.accountNumber ? "#EC0707" : "#D9D9D9",
                      borderWidth: "1px",
                    },
                  },
                  "& .MuiFormHelperText-root": {
                    fontFamily: "Inter400 !important",
                    fontSize: "12px !important",
                    color: "#FF0000 !important",
                  },
                  width: "399px",
                  height: "42px !important",
                  "@media (max-width: 1250px)": {
                    width: "350px !important",
                  },
                  "@media (max-width: 1150px)": {
                    width: "320px !important",
                  },
                  "@media (max-width: 1080px)": {
                    width: "290px !important",
                  }, "@media (max-width: 1000px)": {
                    width: "320px !important",
                  },
                  "@media (max-width: 769px)": {
                    width: "290px !important",
                  },
                  "@media (max-width: 680px)": {
                    width: "288px !important",
                  }
                }}
              />

              {submitAttempted && errors.accountNumber && (
                <span style={{
                  color: "#EC0707",
                  fontSize: "12px",
                  marginTop: "5px",
                  fontFamily: "Inter400",
                  textAlign: "center",
                }}>
                  {errors.accountNumber}
                </span>
              )}


              <TextField
                variant="outlined"
                placeholder="Confirm bank account number"
                value={confirmAccountNumber}
                onChange={(e) => {
                  const value = e.target.value.trim();
                  if (/^\d*$/.test(value) && value.length <= 18) {
                    handleInputChange("confirmAccountNumber", value);
                  }
                }}

                onPaste={(e) => e.preventDefault()}
                onCopy={(e) => e.preventDefault()}
                autoComplete="off"
                inputProps={{
                  autoComplete: "off",
                  name: "hidden-confirm-account",
                  id: "hidden-confirm-account-" + Math.random().toString(36).substring(2)
                }}
                sx={{
                  backgroundColor: "white",
                  borderRadius: "39px",
                  marginTop: "16px",
                  "& input": {
                    display: "flex",
                    alignItems: "center",
                    padding: "8px 12px",
                    textAlign: "center !important",
                    fontFamily: "Inter400 !important",
                    fontSize: "18px !important",
                    lineHeight: "29px !important",


                    "&::placeholder": {
                      padding: "11px 12px",
                      fontSize: "14px !important",
                      fontFamily: "Inter400 !important",
                      color: "#767676",
                      opacity: 1, // Required for Firefox
                    },
                    "@media (max-width: 1250px)": {
                      "&::placeholder": {
                        fontSize: "14px !important",
                      }
                    },
                    "@media (max-width: 680px)": {
                      "&::placeholder": {
                        fontSize: "14px !important",
                      }
                    },
                  },

                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderRadius: "39px",
                      height: "46px !important",
                      width: "383px !important",
                      borderColor: submitAttempted && errors.confirmAccountNumber ? "#EC0707" : "#D9D9D9",
                      "@media (max-width: 1250px)": {
                        width: "333px !important",
                      },
                      "@media (max-width: 1150px)": {
                        width: "303px !important",
                      },
                      "@media (max-width: 1080px)": {
                        width: "273px !important",
                      },
                      "@media (max-width: 1000px)": {
                        width: "303px !important",
                      },
                      "@media (max-width: 769px)": {
                        width: "273px !important",
                      },
                      "@media (max-width: 680px)": {
                        width: "271px !important",
                      }
                    },
                    "&:hover fieldset": {
                      borderColor: submitAttempted && errors.confirmAccountNumber ? "#EC0707" : "#D9D9D9",  // Keep border color consistent on hover
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: submitAttempted && errors.confirmAccountNumber ? "#EC0707" : "#D9D9D9", // Ensure no border color change on focus
                      borderWidth: "1px",
                    },
                  },
                  "& .MuiFormHelperText-root": {
                    fontFamily: "Inter400 !important",
                    fontSize: "12px !important",
                    color: "#FF0000 !important",
                  },
                  width: "399px",
                  height: "42px !important",
                  "@media (max-width: 1250px)": {
                    width: "350px !important",
                  },
                  "@media (max-width: 1150px)": {
                    width: "320px !important",
                  },
                  "@media (max-width: 1080px)": {
                    width: "290px !important",
                  },
                  "@media (max-width: 1000px)": {
                    width: "320px !important",
                  }, "@media (max-width: 769px)": {
                    width: "290px !important",
                  },
                  "@media (max-width: 680px)": {
                    width: "288px !important",
                  }

                }}
              />


              {submitAttempted && errors.confirmAccountNumber && (
                <span style={{
                  color: "#EC0707",
                  fontSize: "12px",
                  marginTop: "5px",
                  fontFamily: "Inter400",
                  textAlign: "center",
                }}>
                  {errors.confirmAccountNumber}
                </span>
              )}


              <TextField
                variant="outlined"
                placeholder="UPI Id (Optional)"
                value={upiId}
                onChange={(e) => {
                  const value = e.target.value.trim();
                  handleInputChange("upiId", value);
                }}

                autoComplete="off"
                inputProps={{
                  autoComplete: "new-password",
                }}
                sx={{
                  backgroundColor: "white",
                  borderRadius: "39px",
                  marginTop: "16px",
                  "& input": {
                    display: "flex",
                    alignItems: "center",
                    padding: "8px 12px",
                    textAlign: "center !important",
                    fontFamily: "Inter400 !important",
                    fontSize: "18px !important",
                    lineHeight: "29px !important",
                    "&::placeholder": {
                      padding: "11px 12px",
                      fontSize: "14px !important",
                      fontFamily: "Inter400 !important",
                      color: "#767676",
                      opacity: 1, // Required for Firefox
                    },
                  },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderRadius: "39px",
                      borderColor: submitAttempted && errors.upiId ? "#EC0707" : "#D9D9D9",
                    },
                    "&:hover fieldset": {
                      borderColor: submitAttempted && errors.upiId ? "#EC0707" : "#D9D9D9",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: submitAttempted && errors.upiId ? "#EC0707" : "#D9D9D9",
                      borderWidth: "1px",
                    },
                  },
                  "& .MuiFormHelperText-root": {
                    fontFamily: "Inter400 !important",
                    fontSize: "12px !important",
                    color: "#FF0000 !important",
                  },
                  width: "100%",
                  maxWidth: "400px",
                  "@media (max-width: 680px)": {
                    width: "288px !important",
                  }
                }}
              />


              {submitAttempted && errors.upiId && (
                <span style={{
                  color: "#EC0707",
                  fontSize: "12px",
                  marginTop: "4px",
                  fontFamily: "Inter400",
                  textAlign: "center",
                }}>
                  {errors.upiId}
                </span>
              )}


            </Grid2>


            {serverError && (
              <span style={{
                color: "#EC0707",
                fontSize: "12px",
                marginTop: "5px",
                fontFamily: "Inter400",
                textAlign: "center",
              }}>
                {serverError}
              </span>
            )}



            <Grid2 container
            className={BankStyles.but_card}
              spacing={2}
              direction={{ xs: "column-reverse !important", md: "row !important" }}>
              <Grid2>
                {!userData?.steps?.["Link Bank Account"]?.status && <Button
                  // className={SignatureStyles.skip_button}
                  className={BankStyles.skip_button}

                  variant="outlined"
                onClick={handleSkipBV}
                >
                  Skip Now
                </Button>}
              </Grid2>
              <Grid2>
                <Button
                  className={BankStyles.con_button}
                  // disabled={!isFormValid}
                  onClick={handleContinue}
                >
                  {loading ? 'Verifying...' : 'Verify'}
                </Button>
              </Grid2>
            </Grid2>

          </>
        }


        {/* after verify */}

        {
          bankDetailsPage &&
          <>

            <Grid2 sx={{
              display: "flex", flexDirection: "row", gap: "15px !important",
              "@media (max-width: 500px)": {
                flexDirection: "column",
              }
            }}>

              <Grid2 className={BankStyles.bank_details}>
                {/* <img src={bankLogo} alt="logo" className={BankStyles.bankLogo_style} /> */}

                <Grid2 sx={{ display: "flex", flexDirection: "column" }}>
                  <Grid2 sx={{ display: "flex", flexDirection: "row", padding: "15px 0px 0px 10px !important" }}>
                    <Typography className={BankStyles.bank_name}>
                      {
                        bankDetails ? bankDetails?.bank_name : bankData?.bank_name
                      }
                    </Typography>
                    <span className={BankStyles.accno}>**********{accNo}</span>
                  </Grid2>
                  <Typography className={BankStyles.savings}>{bankDetails ? bankDetails?.account_type : bankData?.account_type} Account</Typography>
                </Grid2>

                {/* 
              <Radio
                checked={true}
                value="bank"
                name="bank-options"
                className={BankStyles.radio}
              /> */}
              </Grid2>


              <Typography className={BankStyles.linkbank} onClick={handleBack}>
                link other bank
              </Typography>
            </Grid2>

            <Grid2 className={BankStyles.details_card}>
              <Typography className={BankStyles.label1}>Name:</Typography>
              <Typography className={BankStyles.title1}>{bankDetails ? bankDetails?.account_name : bankData?.account_name}</Typography>

              <Typography className={BankStyles.label1}>Bank Account:</Typography>
              <Typography className={BankStyles.title1}>{bankDetails ? bankDetails?.account_number : bankData?.account_number}</Typography>

              <Typography className={BankStyles.label1}>IFSC Code:</Typography>
              <Typography className={BankStyles.title1}>{bankDetails ? bankDetails?.ifsc_code : bankData?.ifsc_code}</Typography>

              <Typography className={BankStyles.label1}>Account type:</Typography>
              <Typography className={BankStyles.title1}>{bankDetails ? bankDetails?.account_type : bankData?.account_type} Account</Typography>

              <Typography className={BankStyles.label1}>Branch:</Typography>
              <Typography className={BankStyles.title1}>{bankDetails ? bankDetails?.branch_name : bankData?.branch_name}</Typography>
            </Grid2>

            <Grid2 className={BankStyles.but_card}>

              {/* <Grid2>
                <Button
                  className={BankStyles.bankdetails_skip_button}
                  variant="outlined"
                  onClick={handleBack}
                >
                  Back
                </Button>
              </Grid2> */}
              <Grid2>
                <Button
                  className={BankStyles.bankdetails_con_button}
                  // disabled={!isFormValid}
                  onClick={handleDetailsContinue}

                >
                  Continue
                </Button>
              </Grid2>
            </Grid2>
          </>
        }

        {/* Success*/}

        {
          bankSuccess &&
          <>
            <img src={success} alt="successLogo" className={BankStyles.success} />
            <Typography className={BankStyles.success_text}>
              Bank linked Successfully to Tradeboss
            </Typography>

            {/* <Typography className={BankStyles.success_subtext}>
              For  {
                bankDetails ? bankDetails.bank_name : bankData.bank_name
              } account ending with **********{accNo}
              </Typography> */}

            <Button
              className={BankStyles.con_button}
              sx={{ marginTop: "90px !important" }}
              // disabled={!isFormValid}
              onClick={handleBankOk}
            >
              OK
            </Button>

          </>
        }



        {/*cheque Upload */}

        {
          chequeStatus &&
          <>
            <Typography style={{
              color: "#EC0707",
              fontSize: "14px",
              marginTop: "10px",
              fontFamily: "Inter500",
              width: "80%",
              textAlign: "center"
            }} >{bankServerError}</Typography>
            <Typography className={BankStyles.manual_title}>Manual Cheque Upload</Typography>

            <Typography className={BankStyles.manual_subtitle}>Provide below documents in JPG or PNG form.</Typography>
            <Box sx={{ marginTop: "7px", position: "relative" }}>
              <FileUploader
                multiple={false}
                maxSize={"1mb"}
                hoverTitle="rAI"
                label="Upload or drop a file right here"
                name="file"
                handleChange={(file) => {
                  if (chequeFileUploader) handlePicFile(file);
                }}
              >
                <Box
                  className={BankStyles.fileuploader}
                  sx={{

                    border: chequeFileUploader
                      ? "2px dashed #aaa"
                      : "2px dashed #ccc",
                    borderRadius: "10px",
                    cursor: chequeFileUploader ? "pointer" : "not-allowed",
                    backgroundColor: chequeFileUploader
                      ? "transparent"
                      : "#f5f5f5",
                  }}

                >
                  <Typography className={BankStyles.fileuploader_txt}
                    color={chequeFileUploader ? "text.primary" : "text.disabled"}>
                   
                    {chequeFileUploader
                      ? "Drag and Drop here / "
                      : "Uploader Disabled"}
                    {chequeFileUploader && (
                      <span
                        className={BankStyles.fileuploader_txt1}

                      >
                        Browse File
                      </span>
                    )}
                  </Typography>
                </Box>
              </FileUploader>

              {/* Locker and Secure outside FileUploader */}
              <Box
                className={BankStyles.secure_card}
              >
                <img
                  src={lock}
                  alt="locker"
                  style={{
                    width: "10px",
                    height: "12.5px",
                  }}
                />
                <Typography
                  className={BankStyles.secure_txt}
                >
                  Secure
                </Typography>
              </Box>
            </Box>

            {fileName && (
              <Typography
                style={{
                  marginTop: "20px ",
                  fontSize: "15px",
                  fontFamily: "Inter400 !important",
                  color: "#000000",
                }}
              >
                {fileName}
              </Typography>
            )}

            {chequeError && (
              <Typography
                style={{
                  marginTop: "20px",
                  fontSize: "15px",
                  fontFamily: "Inter400 !important",
                  color: "#F44748",
                  width: "70%",
                  textAlign: "center"
                }}
              >
                {chequeError}
              </Typography>
            )}



            {/* <Grid2 className={BankStyles.but_card} sx={{ marginTop: chequeData || chequeError ? "10px!important" : "20px !important" }}>




              <Button
                className={BankStyles.con_button}
                disabled={!enable}
                onClick={handleChequeUpload}
              >
                {loading ? 'Verifying...' : 'Verify'}
              </Button>
            </Grid2> */}
          </>
        }





        <Box className={BankStyles.card}  >
          <img
            src={icon} // Replace with your image URL
            alt="Checkmark"
            className={BankStyles.icon}
          />
          <Typography className={BankStyles.txt}>
            Your account details are safe & secure with us.
          </Typography>
        </Box>
      </Box>
      </Box>
    </main>
  );
}